module.exports = __webpack_public_path__ + "img/hzfp42.b97768a4.png";